
export default {
  name: 'AiSummaryButton',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
